/* Rescuevation Footer (rescu-ft-a/b/c): Linkspalten als Klapplisten auf dem Handy.
   Ohne JavaScript bleiben alle Spalten offen, es geht also nichts verloren.
   Am Desktop sind die Spalten immer offen und die Überschrift klappt nichts zu. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');

  function abgleichen() {
    var spalten = document.querySelectorAll('[data-rescu-ft-acc]');
    for (var i = 0; i < spalten.length; i++) {
      spalten[i].open = !mq.matches;
    }
  }

  document.addEventListener('click', function (e) {
    var kopf = e.target.closest && e.target.closest('[data-rescu-ft-acc] > summary');
    if (kopf && !mq.matches) e.preventDefault();
  });

  abgleichen();
  if (mq.addEventListener) {
    mq.addEventListener('change', abgleichen);
  } else if (mq.addListener) {
    mq.addListener(abgleichen);
  }
})();
